import React from "react";

const DEFAULT_COLOR = "#3B82F6";
const DEFAULT_SIZE = 50;

/** Vòng xoay loading (không kèm overlay) — dùng thay DotLoader */
export const SpinnerRing = ({
  loading = true,
  size = DEFAULT_SIZE,
  color = DEFAULT_COLOR,
  "aria-label": ariaLabel = "Loading Spinner",
  "data-testid": dataTestId = "loader",
}) => {
  if (!loading) return null;

  const stroke = Math.max(4, Math.round(size * 0.1));

  return (
    <div
      data-testid={dataTestId}
      role="status"
      aria-label={ariaLabel}
      className="custom-spinner-ring"
      style={{
        width: size,
        height: size,
        background: `
          radial-gradient(farthest-side, ${color} 94%, transparent) top / ${stroke}px ${stroke}px no-repeat,
          conic-gradient(from 0deg, transparent 0deg, ${color}14 90deg, ${color} 320deg, ${color} 360deg)
        `,
        WebkitMask: `radial-gradient(farthest-side, transparent calc(100% - ${stroke}px), #000 calc(100% - ${stroke}px))`,
        mask: `radial-gradient(farthest-side, transparent calc(100% - ${stroke}px), #000 calc(100% - ${stroke}px))`,
      }}
    />
  );
};

/** Overlay loading toàn vùng (LoadingContext) */
const CustomSpinner = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="spinner-loading">
      <div className="spinner-loading-content">
        <SpinnerRing loading size={48} />
      </div>
    </div>
  );
};

export default CustomSpinner;
